import { autoinject } from 'aurelia-framework';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { DemoDataService } from 'app/demo/services/demo-data-service';
import { EssAutocompleteCustomElement } from 'app/shared/elements/forms/ess-autocomplete';
import { guid } from 'app/shared/lib/guid';

@autoinject()
export class DemoEssAutocompletePage extends ComponentBase {

    protected autocompleteOptions: Array<string> = ['off', 'on'];
    protected id: guid = guid();

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly service: DemoDataService,
        ...rest: any[]) {
        super(...rest);
        this.logger.source = this;
    }

    ////****************** Example 1 ********************************************////
    protected searchQuery: string | null = null;
    protected searchResults: any[] = [];     // array of search results from API for autocomplete
    protected $essAutocomplete!: EssAutocompleteCustomElement;

    protected async searchData(value: string): Promise<void> {
        await this.doLoad(async () => {
            // Reset Results
            if(!value) {
                if(this.searchResults) this.searchResults = [];
                return;
            }

            // Check Minimum Search Length
            if(value.length < 2) {
                return;
            }

            // Fetch Results
            const response = await this.service.searchData('example-states', value, ['name', 'abbrv']);
            this.searchResults = response.results;
        });
    }

    protected async selectData(item: any): Promise<void> {
        if(!item) { return; }

        // Perform an action when an item is selected

        // clear query and search results (and thus hide the auto-complete result list)
        //this.searchQuery = null;
        //this.searchResults.splice(0);
    }

    ////****************** Example 2 ********************************************////
    protected $essAutocompleteEx2!: EssAutocompleteCustomElement;
    protected searchQueryEx2: string | null = null;
    protected searchResultsEx2: any[] = [];     // array of search results from API for autocomplete
    protected selectedItemEx2: string | null = null;
    protected ex2Label: string | null = 'Search Data';
    protected ex2RequiredValidatorLabel: string | null = 'Datum';

    protected async searchDataEx2(value: string): Promise<void> {
        await this.doLoad(async () => {
            // Reset Results
            if(!value) {
                if(this.searchResultsEx2) this.searchResultsEx2 = [];
                return;
            }

            // Check Minimum Search Length
            if(value.length < 2) {
                return;
            }

            // Fetch Results
            const response = await this.service.searchData('example-states', value, ['name', 'abbrv']);
            this.searchResultsEx2 = response.results;
        });
    }

    protected async selectDataEx2(item: any): Promise<void> {
        if(!item) { return; }

        // Perform an action when an item is selected
        this.selectedItemEx2 = item;

        // clear query and search results (and thus hide the auto-complete result list)
        //this.searchQuery = null;
        //this.searchResults.splice(0);
    }

}
